// // import React from 'react';
// // import { features } from '../mockData';

// // const Features = () => {
// //   return (
// //     <section id="features" className="py-28 px-6 bg-gradient-mixed-subtle bg-tech-grid">
// //       <div className="max-w-7xl mx-auto">
// //         <div className="text-center mb-24">
// //           <h2 className="text-5xl md:text-6xl font-bold mb-8 leading-tight">{features.mainTitle}</h2>
// //           <p className="text-xl text-gray-600 leading-relaxed">{features.mainSubtitle}</p>
// //         </div>
// //         <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
// //           {features.items.map((feature, index) => (
// //             <div key={index} className="group">
// //               <div className="rounded-3xl overflow-hidden mb-8 shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2">
// //                 <img src={feature.image} alt={feature.title} className="w-full h-72 object-cover group-hover:scale-110 transition-transform duration-700" />
// //               </div>
// //               <h3 className="text-2xl md:text-3xl font-bold mb-4">{feature.title}</h3>
// //               <p className="text-gray-600 text-lg leading-relaxed">{feature.description}</p>
// //             </div>
// //           ))}
// //         </div>
// //       </div>
// //     </section>
// //   );
// // };

// // export default Features;

// import React from 'react';
// import { features } from '@/mockData';

// const Features = () => {
//   return (
//     // DIUBAH: Dihapus 'bg-gradient-mixed-subtle bg-tech-grid'
//     <section id="features" className="py-28 px-6">
//       <div className="max-w-7xl mx-auto">
//         <div className="text-center mb-24">
//           {/* DIUBAH: Teks judul diubah menjadi 'text-white' */}
//           <h2 className="text-5xl md:text-6xl font-bold mb-8 leading-tight text-white">{features.mainTitle}</h2>
//           {/* DIUBAH: Teks subjudul diubah menjadi 'text-gray-300' */}
//           <p className="text-xl text-gray-300 leading-relaxed">{features.mainSubtitle}</p>
//         </div>
//         <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
//           {features.items.map((feature, index) => (
//             <div key={index} className="group justify-center items-center">
//               <div className="rounded-3xl overflow-hidden mb-8 shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 ">
//                 <img src={feature.image} alt={feature.title} className="w-40 h-40 object-cover group-hover:scale-100 transition-transform duration-700 justify-center items-center" />
//               </div>
//               {/* DIUBAH: Teks judul fitur diubah menjadi 'text-white' */}
//               <h3 className="text-2xl md:text-3xl font-bold mb-4 text-white">{feature.title}</h3>
//               {/* DIUBAH: Teks deskripsi fitur diubah menjadi 'text-gray-300' */}
//               <p className="text-gray-300 text-lg leading-relaxed">{feature.description}</p>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Features;

import React from 'react';
import { features } from '@/mockData';

const Features = () => {
  return (
    // DIUBAH: Dihapus 'bg-gradient-mixed-subtle bg-tech-grid'
    <section id="features" className="py-28 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-24">
          {/* DIUBAH: Teks judul diubah menjadi 'text-white' */}
          <h2 className="text-5xl md:text-6xl font-bold mb-8 leading-tight text-white">{features.mainTitle}</h2>
          {/* DIUBAH: Teks subjudul diubah menjadi 'text-gray-300' */}
          <p className="text-xl text-gray-300 leading-relaxed">{features.mainSubtitle}</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {features.items.map((feature, index) => (
            <div key={index} className="group flex flex-col items-center text-center">
              <div className="rounded-3xl overflow-hidden mb-8 shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 ">
                <img src={feature.image} alt={feature.title} className="w-40 h-40 object-cover group-hover:scale-100 transition-transform duration-700" />
              </div>
              <h3 className="text-2xl md:text-3xl font-bold mb-4 text-white">{feature.title}</h3>
              <p className="text-gray-300 text-lg leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;